module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado3.a0ec5b70.svg";